<template>
  <div class="redact_container">
    <el-button class="top_btn" @click="addClick">新增</el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      stripe
      border
    >
      <el-table-column property="number" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="recordTime" label="登记日期">
      </el-table-column>
      <el-table-column property="mileMonth" label="当月行驶里程">
      </el-table-column>
      <el-table-column property="mileAll" label="累计行驶里程">
      </el-table-column>
      <el-table-column property="createUserName" label="登记人员">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
          <el-button type="text" @click="goDetele(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <v-addCarTravelMil
      :dialogShow.sync="addCarTravelMilShow"
      :carId="netId"
    ></v-addCarTravelMil>
    <v-redactCarTravelMil :dialogShow.sync="redactCarTravelMilShow"
      :dialogData="redactCarTravelMilData" :carId="netId"></v-redactCarTravelMil>
  </div>
</template>

<script>
import addCarTravelMil from "./tabDialog/addCarTravelMil.vue";
import redactCarTravelMil from './tabDialog/redactCarTravelMil.vue';
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      tableData: [],
      addCarTravelMilShow: false,
      redactCarTravelMilShow:false,
      redactCarTravelMilData:{},
      tableParams: {
        id: 0,
        page: 1,
        limit: 10,
      },
    };
  },
  components: {
    "v-addCarTravelMil": addCarTravelMil,
    "v-redactCarTravelMil":redactCarTravelMil
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableParams.id = this.netId;
      this.tableLoading = true;
      this.$http.getCarMileList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    addClick() {
      this.addCarTravelMilShow = true;
    },
    goRedact(row) {
      this.redactCarTravelMilShow = true;
      this.redactCarTravelMilData = row
      console.log(row);
    },
    goDetele(row) {
      console.log(row);
      this.$confirm('此操作将永久删除此条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.deleteCarMile({ids:[row.id]}).then(res=>{
             if(res.code === 0){
              this.$emit("update:dialogShow", false);
              this.getList();
              this.$message({
            type: 'success',
            message: '删除成功!'
          });
             }
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_carTravelMil.vue